import { lazy } from 'react';
// 渠道列表
const ChannelProviderList = lazy(() => import('pages/channelProviderList'));
// 线下分销渠道管理
const OffLineChannelList = lazy(() => import('pages/offLineChannelList'));

const router = {
    path: '/channelProvider',
    name: '渠道管理',
    icon: 'snippets',
    permission: 111,
    children: [
        {
            path: 'ChannelProviderList',
            name: '渠道列表',
            icon: 'profile',
            permission: 11101,
            component: ChannelProviderList,
        },
        {
            path: 'offLineChannelList',
            name: '线下分销渠道管理',
            icon: 'profile',
            permission: 11102,
            component: OffLineChannelList,
        },
    ],
};

export default router;
